function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { ConsoleApiName } from '../../tools/display';
import { NO_ERROR_STACK_PRESENT_MESSAGE, isError } from '../error/error';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
import { getExperimentalFeatures } from '../../tools/experimentalFeatures';
import { buildTags } from '../tags';
import { INTAKE_SITE_STAGING, INTAKE_SITE_US1_FED } from '../intakeSites';
import { BufferedObservable, Observable } from '../../tools/observable';
import { clocksNow } from '../../tools/utils/timeUtils';
import { displayIfDebugEnabled, startMonitorErrorCollection } from '../../tools/monitor';
import { sendToExtension } from '../../tools/sendToExtension';
import { performDraw } from '../../tools/utils/numberUtils';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { combine } from '../../tools/mergeInto';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { getConnectivity } from '../connectivity';
import { canUseEventBridge, createFlushController, createHttpRequest, getEventBridge, createBatch } from '../../transport';
import { DISCARDED } from '../../tools/abstractHooks';
import { globalObject, isWorkerEnvironment } from '../../tools/globalObject';
import { TelemetryType } from './rawTelemetryEvent.types';
var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var METRIC_SAMPLE_RATE = 1;
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
var telemetryObservable;
export function getTelemetryObservable() {
  if (!telemetryObservable) {
    telemetryObservable = new BufferedObservable(100);
  }

  return telemetryObservable;
}
export function startTelemetry(telemetryService, configuration, hooks, reportError, pageMayExitObservable, createEncoder) {
  var observable = new Observable();

  var _startTelemetryTransp = startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, observable),
      stop = _startTelemetryTransp.stop;

  var _startTelemetryCollec = startTelemetryCollection(telemetryService, configuration, hooks, observable),
      enabled = _startTelemetryCollec.enabled,
      metricsEnabled = _startTelemetryCollec.metricsEnabled;

  return {
    stop: stop,
    enabled: enabled,
    metricsEnabled: metricsEnabled
  };
}
export function startTelemetryCollection(telemetryService, configuration, hooks, observable) {
  var _telemetryEnabledPerT;

  var metricSampleRate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : METRIC_SAMPLE_RATE;
  var alreadySentEventsByKind = {};
  var telemetryEnabled = !TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = (_telemetryEnabledPerT = {}, _defineProperty(_telemetryEnabledPerT, TelemetryType.LOG, telemetryEnabled), _defineProperty(_telemetryEnabledPerT, TelemetryType.CONFIGURATION, telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate)), _defineProperty(_telemetryEnabledPerT, TelemetryType.USAGE, telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate)), _defineProperty(_telemetryEnabledPerT, "metric", telemetryEnabled && performDraw(metricSampleRate)), _telemetryEnabledPerT);
  var runtimeEnvInfo = getRuntimeEnvInfo();
  var telemetryObservable = getTelemetryObservable();
  telemetryObservable.subscribe(function (_ref) {
    var rawEvent = _ref.rawEvent,
        metricName = _ref.metricName;

    if (metricName && !telemetryEnabledPerType['metric'] || !telemetryEnabledPerType[rawEvent.type]) {
      return;
    }

    var kind = metricName || rawEvent.status || rawEvent.type;
    var alreadySentEvents = alreadySentEventsByKind[kind];

    if (!alreadySentEvents) {
      alreadySentEvents = alreadySentEventsByKind[kind] = new Set();
    }

    if (alreadySentEvents.size >= configuration.maxTelemetryEventsPerPage) {
      return;
    }

    var stringifiedEvent = jsonStringify(rawEvent);

    if (alreadySentEvents.has(stringifiedEvent)) {
      return;
    }

    var defaultTelemetryEventAttributes = hooks.triggerHook(1
    /* HookNames.AssembleTelemetry */
    , {
      startTime: clocksNow().relative
    });

    if (defaultTelemetryEventAttributes === DISCARDED) {
      return;
    }

    var event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
    observable.notify(event);
    sendToExtension('telemetry', event);
    alreadySentEvents.add(stringifiedEvent);
  });
  telemetryObservable.unbuffer();
  startMonitorErrorCollection(addTelemetryError);
  return {
    enabled: telemetryEnabled,
    metricsEnabled: telemetryEnabledPerType['metric']
  };

  function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
    var clockNow = clocksNow();
    var event = {
      type: 'telemetry',
      date: clockNow.timeStamp,
      service: telemetryService,
      version: "6.24.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(rawEvent, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity(),
        sdk_setup: "npm"
      }),
      ddtags: buildTags(configuration).join(','),
      experimental_features: Array.from(getExperimentalFeatures())
    };
    return combine(event, defaultTelemetryEventAttributes);
  }
}

function startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, telemetryObservable) {
  var cleanupTasks = [];

  if (canUseEventBridge()) {
    var bridge = getEventBridge();
    var telemetrySubscription = telemetryObservable.subscribe(function (event) {
      return bridge.send('internal_telemetry', event);
    });
    cleanupTasks.push(telemetrySubscription.unsubscribe);
  } else {
    var endpoints = [configuration.rumEndpointBuilder];

    if (configuration.replica && isTelemetryReplicationAllowed(configuration)) {
      endpoints.push(configuration.replica.rumEndpointBuilder);
    }

    var telemetryBatch = createBatch({
      encoder: createEncoder(4
      /* DeflateEncoderStreamId.TELEMETRY */
      ),
      request: createHttpRequest(endpoints, configuration.batchBytesLimit, reportError),
      flushController: createFlushController({
        messagesLimit: configuration.batchMessagesLimit,
        bytesLimit: configuration.batchBytesLimit,
        durationLimit: configuration.flushTimeout,
        pageMayExitObservable: pageMayExitObservable,
        // We don't use an actual session expire observable here, to make telemetry collection
        // independent of the session. This allows to start and send telemetry events earlier.
        sessionExpireObservable: new Observable()
      }),
      messageBytesLimit: configuration.messageBytesLimit
    });
    cleanupTasks.push(telemetryBatch.stop);

    var _telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);

    cleanupTasks.push(_telemetrySubscription.unsubscribe);
  }

  return {
    stop: function stop() {
      return cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}

function getRuntimeEnvInfo() {
  var _a;

  return {
    is_local_file: ((_a = globalObject.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'file:',
    is_worker: isWorkerEnvironment
  };
}

export function resetTelemetry() {
  telemetryObservable = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */

function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}

export function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);
  getTelemetryObservable().notify({
    rawEvent: _objectSpread({
      type: TelemetryType.LOG,
      message: message,
      status: "debug"
      /* StatusType.debug */

    }, context)
  });
}
export function addTelemetryError(e, context) {
  getTelemetryObservable().notify({
    rawEvent: _objectSpread(_objectSpread({
      type: TelemetryType.LOG,
      status: "error"
      /* StatusType.error */

    }, formatError(e)), context)
  });
}
export function addTelemetryConfiguration(configuration) {
  getTelemetryObservable().notify({
    rawEvent: {
      type: TelemetryType.CONFIGURATION,
      configuration: configuration
    }
  });
}
export function addTelemetryMetrics(metricName, context) {
  getTelemetryObservable().notify({
    rawEvent: _objectSpread({
      type: TelemetryType.LOG,
      message: metricName,
      status: "debug"
      /* StatusType.debug */

    }, context),
    metricName: metricName
  });
}
export function addTelemetryUsage(usage) {
  getTelemetryObservable().notify({
    rawEvent: {
      type: TelemetryType.USAGE,
      usage: usage
    }
  });
}
export function formatError(e) {
  if (isError(e)) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }

  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "Uncaught"
    /* NonErrorPrefix.UNCAUGHT */
    .concat(" ", jsonStringify(e))
  };
}
export function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return frame.url.startsWith(allowedFrameUrl);
    });
  });
  return stackTrace;
}